import { getApiBaseUrl } from 'src/api/config/apiBaseUrl';
import { createCsrfAwareAxiosInstance } from 'src/api/common/http/createCsrfAwareAxiosInstance';

const waAxiosInstance = createCsrfAwareAxiosInstance(getApiBaseUrl(), '/api/wa/csrf');

export default waAxiosInstance;
